import {Client as _Client} from '../../../shared-models/public/client';

export class Client extends _Client{
}

export namespace Client{
	export import RestTypes=_Client.RestTypes;
}
